import { Component, computed, EventEmitter, inject, Input, OnChanges, Output, signal, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { CurrencyBalances, WalletBalances } from '@olv/ui-shared/models/wallet.model';
import { NetworkMetadataService } from '@olv/ui-shared/services/network-metadata.service';
import { groupBalancesByAsset } from '@olv/ui-shared/utils/asset-balance.utils';
import { EmptyStateComponent } from '../empty-state/empty-state.component';
import { AssetCardComponent } from '../asset-card/asset-card.component';

@Component({
  selector: 'app-balance-breakdown',
  standalone: true,
  imports: [NgxSkeletonLoaderComponent, EmptyStateComponent, AssetCardComponent],
  templateUrl: './balance-breakdown.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./balance-breakdown.component.scss'],
})
export class BalanceBreakdownComponent implements OnChanges {
  @Input() walletBalances: WalletBalances | null = null;
  @Input() isLoading = false;
  @Input() error: string | null = null;
  @Input() showIncludeMerchants = false;
  @Input() includeMerchants = false;
  @Output() includeMerchantsChange = new EventEmitter<boolean>();

  protected readonly metadata = inject(NetworkMetadataService);
  private readonly balances = signal<CurrencyBalances[]>([]);
  readonly assets = computed(() => groupBalancesByAsset(this.balances(), this.metadata));
  readonly skeletonCards = [1, 2, 3, 4, 5, 6];

  constructor() {
    this.metadata.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['walletBalances']) {
      this.balances.set(this.walletBalances?.currencyBalances ?? []);
    }
  }

  onIncludeMerchantsToggle(checked: boolean): void {
    this.includeMerchants = checked;
    this.includeMerchantsChange.emit(checked);
  }
}
